import { Subject, debounceTime } from 'rxjs';
import { Attachment } from './attachment';
import { CoordinatorService, MANIFEST_STORE_DELAY } from './coordinator.service';

export class Attachment$ {
    private _id2AttMp = new Map<string, Attachment>();
    private _targetId2AttMp = new Map<string, Set<Attachment>>();
    private _editMap = new Map<string, Attachment>();

    private _markForManifestStoreSubject$ = new Subject<void>();
    private _markForManifestStore$ = this._markForManifestStoreSubject$.pipe(
        debounceTime(MANIFEST_STORE_DELAY),
    );

    constructor(private coords: CoordinatorService) {
        this._markForManifestStore$.subscribe(() => this._manifestStore());
    }

    markForManifestStore() {
        this._markForManifestStoreSubject$.next();
    }

    get canAttach() {
        return (
            !this.coords.project$.current?.isCloud ||
            this.coords.project$.current?.team?.currentUser?.canAttach
        );
    }

    get attachments() {
        return Array.from(this._id2AttMp.values());
    }

    attachmentLs(itmId: string) {
        return Array.from(this._targetId2AttMp.get(itmId) || []);
    }

    add(att: Attachment) {
        this._id2AttMp.set(att.id, att);
        let s = this._targetId2AttMp.get(att.targetId);
        if (!s) {
            s = new Set<Attachment>();
            this._targetId2AttMp.set(att.targetId, s);
        }
        s.add(att);
    }

    delete(att: Attachment) {
        this._id2AttMp.delete(att.id);
        this._targetId2AttMp.get(att.targetId)?.delete(att);
    }

    createDialog(targetId: string, isStandalone = false) {
        const att = new Attachment(this.coords, { targetId: targetId });
        this._editMap.clear();
        this._editMap.set(att.id, att);
        this.coords.display$.dialog$.next({
            action: 'attachment',
            attachment: att,
            isStandalone: isStandalone,
        });
    }

    editDialog(att: Attachment) {
        this._editMap.clear();
        this._editMap.set(att.id, att);
        this.coords.display$.dialog$.next({
            action: 'edit-attachment',
            attachment: att,
        });
    }

    // async saveResponse(params: any) {
    //     try {
    //         const fH = params.result.fH as any;
    //         const attId = params.result.params.id;
    //         const att = this._id2AttMp.get(attId) || this._editMap.get(attId);
    //         att?.informFileSaved(fH);
    //         this.coords.user$.cloudAttachmentManager?.addFilehandle(fH);
    //     } catch (e) {
    //         console.log('saveResponseError', e);
    //     }
    // }

    private _manifestStore() {
        this.coords.manifest$.store({
            type: 'attachment',
            id: `attachmentLs_${this.coords.project$.currentId}`,
            valueMap: new Map<string, any[]>([['attachmentLs', this.storeLs(false)]]),
        });
    }

    storeLs(isReportProject: boolean) {
        let ls = Array.from(this._id2AttMp.values());
        if (!isReportProject) ls = ls.filter((att) => att.isOwned);
        return ls.map((att) => att.save());
    }

    load3(params: any) {
        if (!params) return;
        try {
            for (const a of Array.from(this._id2AttMp.values())) {
                if (a.ownerId == params.ownerId) a.delete();
            }

            for (const a of params.attachmentLs) {
                a.ownerId = params.ownerId;
                const att = new Attachment(this.coords, a);
                this.add(att);
            }
        } catch (e) {
            this.coords.utils$.consoleError('ATTACHMENT LOAD3 ERROR', e);
        }
    }
}
